// @flow

import { connect } from 'react-redux';
import PlannedDowntimeModal from './planneddowntime';
import { closePlannedDowntimeModal } from '../../../services/ui';

export type Props = {
  plannedDowntimeModalIsOpen: boolean,
  closePlannedDowntimeModal: Function,
};

const mapState = ({ ui }) => ({
  plannedDowntimeModalIsOpen: ui.plannedDowntimeModalIsOpen,
});

const mapDispatch = {
  closePlannedDowntimeModal,
};

export default connect(
  mapState,
  mapDispatch,
)(PlannedDowntimeModal);
